import moment from 'moment';
import React from 'react';
// Conference testimonials email with CPD
const NineStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    register_link,
    video_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>{client_name ? `Hi ${client_name},` : ` Hi [Recipient's Name],`}</p>

      <p>
        At IFERP, we’ve had the privilege of hosting impactful conferences
        across the globe, and the feedback from our attendees has been nothing
        short of inspiring.
      </p>
      <p>Here’s what some of them have to say:</p>
      <p>
        <strong>
          {video_link ? (
            <>
              🌟
              <a
                href={video_link}
                target="_blank"
                // rel="noopener noreferrer"
              >
                Video Link
              </a>
              🌟
            </>
          ) : (
            '🌟 [Video Link] 🌟'
          )}
        </strong>
      </p>

      <p>
        {conference_short_name
          ? conference_short_name
          : `[Conference Short Name]`}{' '}
        is also <strong>CPD accredited</strong>, meaning you’ll earn a globally
        recognized certification that elevates your professional credentials.
      </p>

      <p>
        Don’t miss your chance to: <br />
        ✅ Gain valuable insights from industry experts <br />
        ✅ Network with like-minded professionals <br />✅ Earn a CPD
        certification
      </p>

      <p>
        With an exciting lineup of speakers, sessions, and networking
        opportunities, this is an event you won’t want to miss.
      </p>

      <p>
        {register_link ? (
          <>
            👉 Register Now:{' '}
            <a
              href={register_link}
              target="_blank"
              // rel="noopener noreferrer"
            >
              Click Here
            </a>
          </>
        ) : (
          '👉 Register Now: [Registration Link]'
        )}
      </p>
      <p>
        Let me know if you have any questions or need assistance with
        registration. Looking forward to seeing you there!
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default NineStepTemplate;
